import { SHOW_OVERLAY } from "core-web/state/models/Overlay/constants";
import store from "core-web/state/store";

export const showOverlay =
    (current, data = {}, wrapper = null) =>
    (dispatch) => {
        dispatch({
            type: SHOW_OVERLAY,
            current,
            data,
            wrapper,
        });
    };

export default (current, data, wrapper) => store.dispatch(showOverlay(current, data, wrapper));
